import React, { useEffect, useState } from 'react';
import Icon from '@sabre/spark-react-core/icon';
import Modal from '@sabre/spark-react-core/modal';
import {
    func,
    object,
    string,
    any
} from 'prop-types';
import { ToastContainer, toast } from 'react-toast';
// import Toast from '@sabre/spark-react-core/toast';
import NoRecord from '../no-record/no-record.jsx';
import Button from '@sabre/spark-react-core/button';
import TextInput from '@sabre/spark-react-core/text-input';
import SelectInput from '@sabre/spark-react-core/select-input';
import TableHeader from '../table-view/table-header.jsx';
import { DateUtil } from '../../../utils/date-util.js';
import {
    URL_SAVE_CRITERIA,
    URL_SAVE_CRITERIA_FILTER_OF_USER_ID,
    URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID,
    URL_DELETE_BULK
} from '../../../end-points.js';
import useApi from '../../../api-wrapper/use-api.js';
import _ from 'lodash';
const StoredCriteria = (
    {
        data,
        currentUser,
        handleClosePopup,
        handleSelectStoredCriteria,
        isOpen,
        reSetStoredCriteriaPopupFlag
    }
) => {
    const [storedCriteriaConfig, setstoredCriteriaConfig] = useState({
        userNameList: [],
        queryList: [],
        selectedUserName: '',
        headerData: [],
        rowData: [],
        searchFilterValue: '',
        isSelectedRow: false,
        isShowDeletePopup: false,
        currentAction: 'onLoad',
        isDataisEdited: false,
        duplicationRecord: [],
        isCurrentUser: false,
        isOtherUser: false,
        closeDefaultRecord: []
    });
    const URL_SAVED_CRITERIA_SEARCH_USER_ID = `${URL_SAVE_CRITERIA}${URL_CORE_PRICING_SAVE_CRITERIA_FILTER_OF_CONTEXT_ID}'${URL_SAVE_CRITERIA_FILTER_OF_USER_ID}'${currentUser}'`;
    const [storedCriteriaApiData, setStoredCriteriaApiData] = useApi({});
    const [storedCriteriaDeleteApi, setStoredCriteriaDeleteApi] = useApi({});
    const [storedCriteriaSaveApi, setStoredCriteriaSaveApi] = useApi({});
    const [isShowNotification, setIsShowNotification] = useState(false);
    const getClonedCopyCollections = (list) => {
        return list.map(item => { return { ...item } })
    };
    const formatHeader = (headerValue) => headerValue.replace(/([A-Z])/g, ' $1').trim();
    const parsingStoredCriteriaData = (storedCriteriaData) => {
        if (storedCriteriaData) {
            return storedCriteriaData.map((list, index) => {
                list.isRowEdit = false;
                list.isQueryNameEdit = false;
                list.isDescriptionEdit = false;
                list.queryName = _.clone(list.title);
                list.userName = _.clone(list.userId);
                list.description = _.clone(list.description);
                list.fav = list.isFavourite;
                list.defaultQueryName = _.clone(list.title);
                list.lastSavedDate = list.lastUpdatedAt && DateUtil.formatDate(list.lastUpdatedAt, DateUtil.DATE_FORMATS.DD_MMM_YY_TIME).toUpperCase();
                list.defaultDescription = _.clone(list.description);
                list.defaultFav = list.fav;
                return list;
            }
            );
        } else
            return []
    };

    const calculateHeader = (data) => {
        return data.map((item) => {
            return { key: item, isAscending: false, isDecending: false, isDefault: true, filterValue: '', isFilterOpen: false, isShowFilterControls: false };
        });
    }
    const getFavoriteFirst = (list) => {
        const sortedList = list.reduce((list, element) => {
            if (element.fav) {
                return [element, ...list];
            }
            return [...list, element];
        }, []);
        const favoriteFirst = sortedList.find((list) => list.fav);
        const existingEditRecord = sortedList.find((list) => (list.queryName !== list.defaultQueryName || list.isFavourite !== list.defaultFav || list.description !== list.defaultDescription));
        if (favoriteFirst && !existingEditRecord) {
            sortedList[0].isRowEdit = true;
        }
        return { sortedList, favoriteFirst };

    };
    useEffect(() => {

        if (!isOpen) {
            handleDeleteQueryName('Cancel');
        } else {
            reSetStoredCriteriaPopupFlag();
        }

    }, [isOpen])
    useEffect(() => {
        const storedCriteriaList = getFavoriteFirst(parsingStoredCriteriaData(storedCriteriaApiData.data.userSearch));
        if (storedCriteriaList.sortedList) {
            const getusers = storedCriteriaList.sortedList.map((list) => {
                return list.userName;
            });
            const uniqueUsers = [...new Set(getusers)];
            const userNameList = uniqueUsers.map((user) => {
                return { label: user, value: user }
            });
            userNameList.unshift({ label: 'All', value: 'All' });
            const tableHeader = {
                fav: false, queryName: '', lastSavedDate: '', description: '', automated: false, autoTime: '', defaultDescription: '', defaultQueryName: '', isDescriptionEdit: false, isQueryNameEdit: false, isRowEdit: false, userName: ''
            };
            const headerDetails = Object.keys(tableHeader).filter((header) => (
                (header === 'fav' || header === 'queryName' || header === 'lastSavedDate' ||
                    header === 'description' || header === 'userName')) && formatHeader(header));

            setstoredCriteriaConfig(
                {
                    ...storedCriteriaConfig,
                    userNameList,
                    queryList: _.clone(storedCriteriaList.sortedList),
                    selectedUserName: userNameList[0].value,
                    headerData: calculateHeader(headerDetails),
                    rowData: _.clone(storedCriteriaList.sortedList),
                    isSelectedRow: storedCriteriaList.favoriteFirst ? true : false,
                    duplicationRecord: [],
                    closeDefaultRecord: _.clone(storedCriteriaList.sortedList)
                }
            );
        }
    }, [storedCriteriaApiData.isLoading])
    useEffect(() => {
        setStoredCriteriaApiData({ method: 'GET', url: URL_SAVED_CRITERIA_SEARCH_USER_ID });
        setstoredCriteriaConfig(
            {
                ...storedCriteriaConfig,
                currentAction: ''
            }
        );
    }, []);
    const calculateUserSelectionQueryNameList = (selectedValue) => {
        const updatedResult = storedCriteriaConfig.queryList.map((list) => {
            list.isRowEdit = false;
            list.isQueryNameEdit = false;
            list.isDescriptionEdit = false;
            list.queryName = _.clone(list.defaultQueryName);
            list.description = _.clone(list.defaultDescription);
            list.fav = _.clone(list.defaultFav);
            return list;
        });
        const filterResult = getFavoriteFirst(updatedResult.filter((list, index) => {
            if (((list.userName === selectedValue || selectedValue === 'All') &&
                list.queryName.includes(storedCriteriaConfig.searchFilterValue) || (!storedCriteriaConfig.searchFilterValue &&
                    (list.userName === selectedValue || selectedValue === 'All')))) {
                return list;
            }
        }));
        const tableHeader = {
            fav: false, queryName: '', lastSavedDate: '', description: '', automated: false, autoTime: '', defaultDescription: '', defaultQueryName: '', isDescriptionEdit: false, isQueryNameEdit: false, isRowEdit: false, userName: ''
        };
        const headerDetails = Object.keys(tableHeader).filter((header) => (
            (header === 'fav' || header === 'queryName' || header === 'lastSavedDate' ||
                header === 'description' || (header === 'userName' && selectedValue === 'All'))) && formatHeader(header));

        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            selectedUserName: selectedValue,
            rowData: [...filterResult.sortedList],
            headerData: calculateHeader(headerDetails),
            isSelectedRow: filterResult.favoriteFirst ? true : false
        });
    }
    const findEditRecords = () => {
        return storedCriteriaConfig.rowData && storedCriteriaConfig.rowData.find((list) => {
            return (list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription || list.fav !== list.defaultFav)
        });
    }
    const enabledSaveButton = () => {
        return storedCriteriaConfig.rowData && storedCriteriaConfig.rowData.find((list) => {
            return ((list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription || list.fav !== list.defaultFav) && list.isRowEdit === true)
        });
    }
    const deleteAuthendication = () => {
        return storedCriteriaConfig.rowData && storedCriteriaConfig.rowData.find((list) => {
            return (list.isRowEdit === true && list.userName === currentUser)
        });
    }
    const handleUserNameChange = (selectedValue) => {
        if (findEditRecords()) {
            setstoredCriteriaConfig({
                ...storedCriteriaConfig,
                isShowDeletePopup: true,
                currentAction: 'Save All'
            });
        } else {
            calculateUserSelectionQueryNameList(selectedValue);
        }

    };

    const handleSearchFilterChange = (searchValue) => {
        const filterData = storedCriteriaConfig.queryList.filter((list) => {
            if ((list.userName === storedCriteriaConfig.selectedUserName || storedCriteriaConfig.selectedUserName === 'All') && (list.queryName.includes(searchValue) || list.queryName.includes(searchValue.toLowerCase()) || list.queryName.includes(searchValue.toUpperCase()))) {
                return list;
            }
        });
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            rowData: [...filterData],
            searchFilterValue: searchValue
        });
    };

    const handleQueryNameClick = (selectedItem, type, column) => {
        const updatedResult = storedCriteriaConfig.rowData.map((list) => {
            if (type === 'cell') {
                if (list.queryName === selectedItem.queryName) {
                    list.isRowEdit = true;
                    if (column === 'queryName')
                        list.isQueryNameEdit = true;
                    else
                        list.isDescriptionEdit = true;
                } else {
                    list.isRowEdit = false;
                    if (list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription || list.fav !== list.defaultFav) {
                        list.isQueryNameEdit = true;
                        list.isDescriptionEdit = true;
                    } else {
                        list.isQueryNameEdit = false;
                        list.isDescriptionEdit = false;
                    }
                }
            } else if (type === 'row') {
                if (list.id === selectedItem.id) {
                    list.isRowEdit = true;
                } else {
                    list.isRowEdit = false;
                    if (list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription || list.fav !== list.defaultFav) {
                        list.isQueryNameEdit = true;
                        list.isDescriptionEdit = true;
                    } else {
                        list.isQueryNameEdit = false;
                        list.isDescriptionEdit = false;
                    }
                }
            }

            return list;
        });
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            rowData: [...updatedResult],
            isSelectedRow: true,

        });
    };
    const storedCriteriaClose = () => {
        handleDeleteQueryName('Cancel');
        return storedCriteriaConfig;

    }
    const handleDeleteQueryName = (currentActionValue) => {
        if (!deleteAuthendication() && currentActionValue === 'Delete') {
            return;
        }
        const selectedRecord = currentActionValue === 'Cancel' ? findEditRecords() : storedCriteriaConfig.isSelectedRow;
        if (selectedRecord && storedCriteriaConfig.rowData.length > 0) {
            const duplicationDetails = queryNameDuplicationEntryValidation('Multiple');
            if (duplicationDetails.userDetails.isOther && !duplicationDetails.userDetails.isCurrent) {
                duplicationDetails.duplicationRecord.map(list => {
                    list.queryName = list.queryName + ' - ' + 'Copy' + ' - ' + list.userName + '--' + Math.floor(Math.random() * 100) + 5;
                });
            } else if (duplicationDetails.userDetails.isOther && duplicationDetails.userDetails.isCurrent) {

                duplicationDetails.duplicationRecord.map(list => {
                    storedCriteriaConfig.queryList.map(subList => {
                        if (subList.userName !== list.userName && list.userName === currentUser && subList.queryName === list.queryName) {
                            list.queryName = list.queryName + ' - ' + 'Copy' + ' - ' + list.userName + '--' + Math.floor(Math.random() * 100) + 5;
                        }
                    });
                });
            }
            reSetStoredCriteriaPopupFlag();
            setstoredCriteriaConfig({
                ...storedCriteriaConfig,
                isShowDeletePopup: true,
                currentAction: currentActionValue === 'Cancel' ? 'Save All' : 'Delete',
                duplicationRecord: duplicationDetails.duplicationRecord,
                isCurrentUser: duplicationDetails.isCurrentUser,
                isOtherUser: duplicationDetails.userDetails.isOther,
                closeDefaultRecord: duplicationDetails.cloneRecords
            });
        } else {
            if (currentActionValue === 'Delete' && storedCriteriaConfig.rowData.length > 0) {
                if (!isShowNotification) {
                    notificationTimeSet();
                    toast.warn('Please select row.');
                }
            } else if (currentActionValue === 'Cancel') {
                handleClosePopup();
            } else
                return;
        }
    };

    const handleQueryNameUpdate = (event, value, type, index) => {
        const pointer = event.target.selectionStart;
        const element = event.target;
        window.requestAnimationFrame(() => {
            element.selectionStart = pointer;
            element.selectionEnd = pointer;
        });
        const updatedRecord = structuredClone(storedCriteriaConfig.rowData);
        if (type === 'queryName')
            updatedRecord[index].queryName = value.toUpperCase();
        else
            updatedRecord[index].description = value.toUpperCase();
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            rowData: [...updatedRecord],
            isSelectedRow: true,
            isDataisEdited: true
        });
    };
    const getList = (dataList) => {
        return dataList.filter(list => list.userName === storedCriteriaConfig.selectedUserName)
    }

    const saveQueryRecords = () => {
        const savedItem = storedCriteriaConfig.rowData.filter((list) => {
            if (list.isRowEdit) {
                return list;
            }
        });
        const updatedDefaultRecord = _.clone(storedCriteriaConfig.queryList);
        let finalRecord = updatedDefaultRecord.map((list) => {
            if (list.id === savedItem[0].id) {
                savedItem[0].defaultQueryName = savedItem[0].queryName;
                savedItem[0].title = savedItem[0].queryName;
                savedItem[0].defaultDescription = savedItem[0].description;
                savedItem[0].defaultFav = savedItem[0].fav;
                savedItem[0].lastSavedDate = DateUtil.formatDate(new Date(), DateUtil.DATE_FORMATS.DD_MMM_YY_TIME).toUpperCase();
                return savedItem[0];
            }
            return list;
        });
        let finalResult = storedCriteriaConfig.rowData.map((list) => {
            if (storedCriteriaConfig.currentAction === 'Save All') {
                list.isDescriptionEdit = false;
                list.isQueryNameEdit = false;
                list.isRowEdit = false;
                list.defaultQueryName = list.queryName;
                list.title = list.queryName;
                list.defaultDescription = list.description;
                list.defaultFav = list.fav;
                if (list.queryName !== list.defaultQueryName
                    && list.description !== list.defaultDescription && list.fav !== list.defaultFav)
                    list.lastSavedDate = DateUtil.formatDate(new Date(), DateUtil.DATE_FORMATS.DD_MMM_YY_TIME).toUpperCase();
            } else if (list.defaultQueryName === savedItem[0].defaultQueryName) {
                savedItem[0].isDescriptionEdit = false;
                savedItem[0].isQueryNameEdit = false;
                savedItem[0].isRowEdit = false;
                return savedItem[0];
            }
            return list;
        });
        const defaultRecord = _.clone(storedCriteriaConfig.queryList);
        const finalSaveAllResult = defaultRecord.filter((list) => list.userName !== storedCriteriaConfig.selectedUserName);
        let result = storedCriteriaConfig.userNameList.length > 2 && storedCriteriaConfig.selectedUserName !== 'All' ? finalSaveAllResult.concat(finalResult) : finalResult;
        const previousEditRow = finalResult.find((list) => list.isQueryNameEdit || list.isDescriptionEdit);

        let finalUpdatedResult = previousEditRow && finalResult.map((list) => {
            if (list.defaultQueryName === previousEditRow.defaultQueryName) {
                list.isRowEdit = true;
            }
            return list;
        });
        if (storedCriteriaConfig.isCurrentUser) {
            if (storedCriteriaConfig.currentAction === 'Save All') {
                result = result.filter(list => {
                    return storedCriteriaConfig.duplicationRecord.every(subList => {
                        if ((subList.queryName === list.queryName && subList.id === list.id)) {
                            return subList;
                        } else if (list.queryName !== subList.queryName)
                            return list;
                    });
                });
                finalResult = storedCriteriaConfig.selectedUserName === 'All' ? result : getList(result);
            } else {
                finalRecord = finalRecord.filter(list => {
                    return (list.queryName !== storedCriteriaConfig.duplicationRecord[0].queryName ||
                        (list.queryName === storedCriteriaConfig.duplicationRecord[0].queryName && list.id === storedCriteriaConfig.duplicationRecord[0].id))
                });

                finalResult = storedCriteriaConfig.selectedUserName === 'All' ? finalRecord : getList(finalRecord);
            }
        }
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            queryList: storedCriteriaConfig.currentAction === 'Save All' ? [...result] : [...finalRecord],
            rowData: previousEditRow ? getFavoriteFirst([...finalUpdatedResult]).sortedList : getFavoriteFirst([...finalResult]).sortedList,
            isSelectedRow: previousEditRow ? getFavoriteFirst([...finalUpdatedResult]).favoriteFirst : getFavoriteFirst([...finalResult]).favoriteFirst,
            isShowDeletePopup: false,
            currentAction: '',
            isDataisEdited: false,
            duplicationRecord: [],
            isCurrentUser: false,
            isOtherUser: false
        });
        toast.success('Record Updated Successfully.....', { backgroundColor: '#268440' });
    };
    useEffect(() => {
        if (storedCriteriaConfig.currentAction === 'Delete' && !storedCriteriaDeleteApi.isLoading && !storedCriteriaDeleteApi.error) {
            const deleteItem = storedCriteriaConfig.rowData.filter((list) => list.isRowEdit);
            const rowDataUpdate = storedCriteriaConfig.rowData.filter((list) => !list.isRowEdit);
            const updatedDefaultRecord = _.clone(storedCriteriaConfig.queryList);
            const queryListUpdate = updatedDefaultRecord.filter((list) => list.queryName !== deleteItem[0].defaultQueryName);
            const previousEditRow = rowDataUpdate.find((list) => list.isQueryNameEdit || list.isDescriptionEdit);
            const finalUpdatedResult = previousEditRow && rowDataUpdate.map((list) => {
                if (list.defaultQueryName === previousEditRow.defaultQueryName) {
                    list.isRowEdit = true;
                }
                return list;
            });
            setstoredCriteriaConfig({
                ...storedCriteriaConfig,
                rowData: previousEditRow ? [...finalUpdatedResult] : [...rowDataUpdate],
                queryList: [...queryListUpdate],
                isSelectedRow: previousEditRow ? true : false,
                isShowDeletePopup: false,
                duplicationRecord: []
            });
            toast.success('Selected record deleted Successfully.', { backgroundColor: '#268440' });
        } else if (storedCriteriaDeleteApi.error && Array.isArray(storedCriteriaDeleteApi.data)) {
            setstoredCriteriaConfig({
                ...storedCriteriaConfig,
                isShowDeletePopup: false
            });
            notificationTimeSet();
            toast.warn(storedCriteriaDeleteApi.message);
        }
    }, [storedCriteriaDeleteApi]);
    useEffect(() => {
        if (storedCriteriaConfig.currentAction !== 'Delete' && storedCriteriaConfig.currentAction !== 'onLoad' && !storedCriteriaSaveApi.isLoading && !storedCriteriaSaveApi.error) {
            saveQueryRecords();
        } else if(storedCriteriaSaveApi.message){
            toast.warn(storedCriteriaSaveApi.message,'error')
        }
    }, [storedCriteriaSaveApi])
    const handleDeleteRecord = () => {
        if (storedCriteriaConfig.currentAction === 'Delete') {
            const deleteItem = storedCriteriaConfig.rowData.filter((list) => list.isRowEdit);
            setStoredCriteriaDeleteApi({ method: 'DELETE', url: URL_DELETE_BULK, data: [deleteItem[0].id] });
        } else {
            const resultData = storedCriteriaConfig.rowData.filter((list) => {
                return (list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription || list.fav !== list.defaultFav)
            });
            const copyCollection = _.cloneDeep(resultData);
            const result = copyCollection.map(list => {
                list.title = _.clone(list.queryName);
                list.isFavourite = list.fav ? list.fav : false;
                delete list.queryName;
                delete list.defaultDescription;
                delete list.defaultFav;
                delete list.fav;
                delete list.defaultQueryName;
                delete list.isDescriptionEdit;
                delete list.isQueryNameEdit;
                delete list.isRowEdit;
                delete list.userName;
                return list;
            });
            const requestObject = result.reduce(
                (obj, item) => Object.assign(obj, { [item.id]: item }), {});

            setStoredCriteriaSaveApi({ method: 'PUT', url: URL_DELETE_BULK, data: requestObject });
            //  saveQueryRecords();
        }
    };

    const handleDeletePopupCloseOnClick = () => {
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            isShowDeletePopup: false,
            currentAction: '',
            duplicationRecord: [],
            isCurrentUser: false,
            isOtherUser: false,
            rowData: storedCriteriaConfig.duplicationRecord.length > 0 ? storedCriteriaConfig.closeDefaultRecord : storedCriteriaConfig.rowData
        });
    };
    const handleDiscardChanges = () => {
        const deleteItem = storedCriteriaConfig.rowData.filter((list) => list.isRowEdit);
        const updatedDefaultRecord = _.clone(storedCriteriaConfig.queryList);
        const queryListUpdate = updatedDefaultRecord.filter((list) => list.queryName === deleteItem[0].defaultQueryName);
        const finalResult = storedCriteriaConfig.rowData.map((list) => {
            if (storedCriteriaConfig.currentAction === 'Save All') {
                list.isDescriptionEdit = false;
                list.isQueryNameEdit = false;
                list.isRowEdit = false;
                list.queryName = _.clone(list.defaultQueryName);
                list.description = _.clone(list.defaultDescription);
                list.fav = list.defaultFav;
            } else if (list.defaultQueryName === queryListUpdate[0].defaultQueryName) {
                queryListUpdate[0].isDescriptionEdit = false;
                queryListUpdate[0].isQueryNameEdit = false;
                queryListUpdate[0].isRowEdit = false;
                return queryListUpdate[0];
            }
            return list;
        });
        const previousEditRow = finalResult.find((list) => list.isQueryNameEdit || list.isDescriptionEdit);
        const finalUpdatedResult = previousEditRow && finalResult.map((list) => {
            if (list.defaultQueryName === previousEditRow.defaultQueryName) {
                list.isRowEdit = true;
            }
            return list;
        });
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            rowData: previousEditRow ? [...finalUpdatedResult] : [...finalResult],
            searchFilterValue: '',
            isSelectedRow: previousEditRow ? true : false,
            isShowDeletePopup: false,
            currentAction: '',
            isDataisEdited: previousEditRow ? true : false,
            duplicationRecord: [],
            isCurrentUser: false,
            isOtherUser: false

        });
        toast.success('Discard successfully.', { backgroundColor: '#268440' });
    }
    const findUserData = (collection1, collection2) => {
        const editUserDetails = { isCurrent: false, isOther: false };
        collection1.map(list => {
            if (list.userName === currentUser) {
                collection2.map(subList => {
                    if (subList.userName === currentUser) {
                        editUserDetails.isCurrent = true;
                    } else {
                        editUserDetails.isOther = true;
                    }
                })
            }
        });
        return editUserDetails;
    }
    const queryNameDuplicationEntryValidation = (type) => {
        let isCurrentUser = false;
        const cloneRecords = _.clone(storedCriteriaConfig.rowData);
        const totalEditRecords = (type === 'Single') ? storedCriteriaConfig.rowData.filter((list) => list.queryName !== list.defaultQueryName) :
            storedCriteriaConfig.rowData.filter((list) => list.queryName !== list.defaultQueryName);
        const duplicationRecords = (type === 'Single') ? totalEditRecords.filter((list) => storedCriteriaConfig.queryList.find((sub) => sub.queryName.toUpperCase() === list.queryName.toUpperCase() && list.isRowEdit === true)) :
            totalEditRecords.filter((list) => storedCriteriaConfig.queryList.some((sub) => sub.queryName.toUpperCase() === list.queryName.toUpperCase()));
        const result = storedCriteriaConfig.queryList.filter(list => duplicationRecords.some(subList => subList.queryName === list.queryName))
        if (duplicationRecords.length > 0) {
            isCurrentUser = findUserData(duplicationRecords, result);
        }
        return { isDuplication: duplicationRecords.length > 0 ? true : false, duplicationRecord: duplicationRecords, isCurrentUser: isCurrentUser.isCurrent, userDetails: isCurrentUser, cloneRecords: cloneRecords }
    };
    const duplicationHandler = (type) => {
        const duplicationDetails = queryNameDuplicationEntryValidation(type);
        if (!duplicationDetails.isDuplication) {
            let isEmptyTitle = false;
            const savedItem = storedCriteriaConfig.rowData.filter((list) => {
                if (list.isRowEdit) {
                    if (!list.queryName)
                        isEmptyTitle = true;
                    return list;
                }
            });
            if (isEmptyTitle) {
                if (!isShowNotification) {
                    console.log(savedItem)
                    notificationTimeSet();
                    toast.warn('Query Name should not empty.');
                }
                return;
            }

            const copyCollection = getClonedCopyCollections(savedItem);
            const result = copyCollection.map(list => {
                list.title = list.queryName;
                list.isFavourite = list.fav ? list.fav : false;
                delete list.queryName;
                delete list.defaultDescription;
                delete list.defaultFav;
                delete list.fav;
                delete list.defaultQueryName;
                delete list.isDescriptionEdit;
                delete list.isQueryNameEdit;
                delete list.isRowEdit;
                delete list.userName;
                return list;
            });
            const requestObject = result.reduce(
                (obj, item) => Object.assign(obj, { [item.id]: item }), {});
            // const totalItems = [];
            // let myObj = Object.assign({});
            // const finalResult = result.map(list => {
            //     const myObject = { [list.id]: list };
            //     console.log(myObject, 'myObject')
            //     totalItems.push(myObject)
            //     myObj = { [list.id]: list };
            //     console.log(myObj, 'myobj')
            //     return myObject;
            // });
            // console.log(totalItems, 'totalItems')
            // const test = finalResult.map(list => {
            //     return Object.assign({}, list);
            // })
            // console.log(test, 'test')
            setStoredCriteriaSaveApi({ method: 'PUT', url: URL_DELETE_BULK, data: requestObject });
            // saveQueryRecords();
        }
        else {
            if (duplicationDetails.userDetails.isOther) {
                duplicationDetails.duplicationRecord.map(list => {
                    if (list.isRowEdit)
                        list.queryName = list.queryName + ' - ' + 'Copy' + ' - ' + list.userName + '--' + Math.floor(Math.random() * 100) + 5;
                });
            }
            setstoredCriteriaConfig({
                ...storedCriteriaConfig,
                isShowDeletePopup: true,
                currentAction: 'Overwrite',
                duplicationRecord: duplicationDetails.duplicationRecord,
                isCurrentUser: duplicationDetails.isCurrentUser,
                isOtherUser: duplicationDetails.userDetails.isOther,
                closeDefaultRecord: duplicationDetails.cloneRecords
            });
        }
    }
    const handleSaveQueryNameList = () => {
        if (findEditRecords())
            duplicationHandler('Single');
        else if (!isShowNotification) {
            notificationTimeSet();
            toast.warn('Please update record and click to save.');
        }
    };
    const notificationTimeSet = () => {
        setTimeout(() => {
            setIsShowNotification(false);
        }, 3000);
        setIsShowNotification(true);
    }
    const handleSelectStoredCriteriaRecord = () => {
        if (storedCriteriaConfig.isSelectedRow) {
            const isEditRow = storedCriteriaConfig.rowData.find((list) => list.queryName !== list.defaultQueryName || list.description !== list.defaultDescription);
            if (isEditRow) {
                if (!isShowNotification) {
                    notificationTimeSet();
                    toast.warn('Please save your existing changes.');
                }
            } else {
                const selectedItem = storedCriteriaConfig.rowData.filter((list) => list.isRowEdit);
                handleSelectStoredCriteria(selectedItem);
            }
        } else if (!isShowNotification) {
            notificationTimeSet();
            toast.warn('Please select row.');
        }
    };
    const updateData = (totalList, item, type, value) => {
        const updatedResult = totalList.map((list) => {
            if (type === 'sorting') {
                if (list.key === item.key) {
                    list.isShowFilterControls = true;
                } else {
                    list.isFilterOpen = false;
                    list.isShowFilterControls = false;
                }
            } else if (type === 'filterChanging') {
                if (list.key === item.key) {
                    list.filterValue = value;
                } else {
                    list.filterValue = '';
                }
            } else {
                if (list.key === item.key)
                    list.isFilterOpen = true;
                else
                    list.isFilterOpen = false;
            }
            return list;
        });
        return updatedResult;
    };

    const handleEnablesHeadersControls = (item, list, isSecondaryTable, isSorting) => {
        if (item.key !== 'queryName' && item.key !== 'lastSavedDate' && item.key !== 'description')
            return;
        const resultData = updateData(list, item, isSorting ? 'sorting' : 'filtering');
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            headerData: [...resultData]
        });
    };
    const updateRecords = (item, totalList) => {
        let currentRecord = 0;
        const updatedResult = totalList.map((list) => {
            if (list.key === item.key) {
                if (item.isDefault || item.isDecending) {
                    list.isAscending = true;
                    list.isDefault = false;
                    list.isDecending = false;
                } else if (item.isAscending) {
                    list.isDecending = true;
                    list.isAscending = false;
                }
                currentRecord = list;
            }

            return list;
        });
        return { updatedResult, currentRecord };
    };
    const handleSorting = (item) => {
        const tableObject = updateRecords(item, storedCriteriaConfig.headerData);
        const currentRecord = tableObject.currentRecord;
        const tableHeader = tableObject.updatedResult;
        const sortedData = storedCriteriaConfig.rowData.sort((a, b) => {
            if (a[currentRecord.key] && (b[currentRecord.key]))
                return a[currentRecord.key].toString().localeCompare(b[currentRecord.key].toString());

        });
        const sortedResult = currentRecord.isAscending ? sortedData : sortedData.reverse();
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            headerData: [...tableHeader],
            rowData: [...sortedResult]
        });
    };
    const handleFilterChange = (value, item) => {
        let finalResult = value.length > 0 ? storedCriteriaConfig.queryList.filter((list) => {
            if (list[item.key] && (list[item.key].toString().includes(value) || list[item.key].toString().includes(value.toUpperCase()) || list[item.key].toString().includes(value.toLowerCase())) &&
                (list.userName === storedCriteriaConfig.selectedUserName || storedCriteriaConfig.selectedUserName === 'All')) {
                return list;
            }
        }) : [...storedCriteriaConfig.queryList]
        const tableHeader = updateData(storedCriteriaConfig.headerData, item, 'filterChanging', value);
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            headerData: [...tableHeader],
            rowData: [...finalResult]
        });
    };
    const handleFavClicked = (item) => {
        if (item.userName !== currentUser) {
            return;
        }
        const updatedList = getFavoriteFirst(storedCriteriaConfig.rowData.map((list) => {
            if (list.defaultQueryName === item.queryName) {
                list.fav = !list.fav;
            }
            return list;
        }));
        setstoredCriteriaConfig({
            ...storedCriteriaConfig,
            rowData: updatedList.sortedList,
            isSelectedRow: updatedList.favoriteFirst ? true : false
        });
    };

    return (
        <div className='stored-criteria-root'>
            <ToastContainer position='top-right' delay={3000} />
            {storedCriteriaConfig.isShowDeletePopup && <div className='core-pricing-delete-popup row'><Modal
                onClose={() => handleDeletePopupCloseOnClick()}
                open={storedCriteriaConfig.isShowDeletePopup}
                title={<div className='spark-mar-l-1'><h3><strong>{`${storedCriteriaConfig.duplicationRecord.length > 0 && storedCriteriaConfig.currentAction !== 'Delete' ?
                    storedCriteriaConfig.isCurrentUser && storedCriteriaConfig.isOtherUser ? ' Overwrite and Copying' : storedCriteriaConfig.isCurrentUser ? 'Overwrite' : 'Copying' : storedCriteriaConfig.currentAction} Confirmation `} </strong></h3></div>}
                titleHeadingLevel={3}
                modalId='dashboard-search-modal'
                className={`dashboard-search-modal${storedCriteriaConfig.isShowDeletePopup ? '' : ' spark-hidden'} `}
                contentClassName='col-xs-12 col-sm-12 col-md-11 col-lg-8 col-xl-6'>
                <div>
                    <div className='row col-md-12 col-lg-12'>
                        {
                            storedCriteriaConfig.duplicationRecord.length > 0 && storedCriteriaConfig.currentAction !== 'Delete' ?
                                <div><strong>{`Saving will ${storedCriteriaConfig.isCurrentUser && storedCriteriaConfig.isOtherUser ? 'Overwrite and Copying' : storedCriteriaConfig.isCurrentUser ? 'Overwrite' : 'Copy'}(`}</strong>
                                    {
                                        storedCriteriaConfig.duplicationRecord.map((list, index, collection) => {
                                            return <strong key={index} className=''>{`${list.defaultQueryName}${index + 1 !== collection.length ? ',' : ''}`}</strong>
                                        })}
                                    <strong>), do you want to continue?</strong></div> :
                                <strong>{`Do you want to ${storedCriteriaConfig.currentAction} these changes?.`}</strong>
                        }
                    </div>
                    <div className='row popup-button col-md-12 col-lg-12'>
                        <Button
                            className='spark-btn-group-secondary select-button-cancel'
                            size={Button.SIZE.SMALL}
                            secondary={true}
                            onClick={() => handleDiscardChanges()}>
                            {storedCriteriaConfig.currentAction === 'Delete' ? 'Discard' : storedCriteriaConfig.currentAction === 'Save All' ? 'Discard All' : 'Discard'}
                        </Button>
                        <Button
                            className='spark-btn-group-primary'
                            size={Button.SIZE.SMALL}
                            primary='true'
                            onClick={handleDeleteRecord}>
                            {storedCriteriaConfig.currentAction === 'Delete' ? 'Delete' : storedCriteriaConfig.currentAction === 'Save All' ? 'Save All' : 'Save'}
                        </Button>
                    </div>
                </div>
            </Modal></div>
            }
            <div className='row'>
                <div data-testid='stored-criteria-title' className='spark-bold spark-large'>Stored Criteria</div>
            </div>
            <div className='row'>
                <div className=' row col-md-6 col-lg-6'>
                    <div className='col-md-4 col-lg-4' data-testid='select-user-title'>Selected User</div>
                    <div className='col-md-8 col-lg-8'>
                        <SelectInput
                            disabled={findEditRecords()}
                            // defaultValue={storedCriteriaConfig.selectedUserName}
                            key={`stored-criteria-key ${storedCriteriaConfig.selectedUserName}`}
                            ariaLabel={storedCriteriaConfig.selectedUserName}
                            name={'stored-criteria-dropdown'}
                            options={storedCriteriaConfig.userNameList}
                            value={storedCriteriaConfig.selectedUserName}
                            data-testid='select-user-drop-down'
                            title='select-user-drop-down'
                            onChange={event => handleUserNameChange(event.target.value)}
                        />
                    </div>
                </div>
                <div className=' row col-md-6 col-lg-6'>
                    <div className='col-md-3 col-lg-3' data-testid='search-label'>Search</div>
                    <div className='col-md-7 col-lg-7'>
                        <TextInput
                            data-testid='search-filter-input'
                            name='search-query-name'
                            value={storedCriteriaConfig.searchFilterValue}
                            onChange={(event, selectedValue) => handleSearchFilterChange(selectedValue)}
                        />
                    </div>
                </div>
            </div>
            <div className='row stored-criteria-icons'>
                <div className='stored-criteria-icons-common stored-criteria-icons-delete'>
                    <Icon name='trash'
                        className='spark-danger'
                        data-testid='delete-icon'
                        size='md'
                        style={(storedCriteriaConfig.isSelectedRow && deleteAuthendication()
                            && storedCriteriaConfig.rowData.length > 0) ? 'fill' : 'line'}
                        label='Delete'
                        onClick={() => handleDeleteQueryName('Delete')}
                    />
                </div>
                <div className='stored-criteria-icons-common'>
                    <Icon name='save'
                        data-testid='save-icon'
                        className='spark-success'
                        size='md'
                        style={enabledSaveButton() ? 'fill' : 'line'}
                        label='Save'
                        onClick={handleSaveQueryNameList}
                    />
                </div>
            </div>
            <div className='row spark-pad-t-.5 view'>
                <div className='table-root'>
                    <table className='stored-criteria-table'>
                        <thead className='stored-criteria-table-body'>
                            <tr className='stored-criteria-table-row'>
                                {
                                    storedCriteriaConfig.headerData.length > 0 && (storedCriteriaConfig.headerData.map((item, headerIndex) => {

                                        return item && <th key={headerIndex} className='table-view-root stored-criteria-table-header-cell'>
                                            <TableHeader
                                                handleEnablesHeadersControls={handleEnablesHeadersControls}
                                                handleSorting={handleSorting}
                                                handleShowSearchFilters={handleEnablesHeadersControls}
                                                handleFilterChange={handleFilterChange}
                                                item={item}
                                                headerData={storedCriteriaConfig.headerData}
                                                rowData={storedCriteriaConfig.rowData}
                                                isScroll={false}
                                            />
                                        </th>

                                    }))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                storedCriteriaConfig.rowData.length > 0 && (storedCriteriaConfig.rowData.map((list, index) => {
                                    return (<tr key={index} className={`stored-criteria-table-row ${list.isRowEdit ? 'stored-criteria-table-selected-row' : (index % 2) === 0 ? 'stored-criteria-table-even-row' : 'stored-criteria-table-odd-row'}`}
                                        onClick={() => handleQueryNameClick(list, 'row')}>
                                        <td className={`row icon-star-padding-top stored-criteria-table-item-center stored-criteria-table-highlighted-cell ${list.userName !== currentUser ? 'disabled-cursor' : ''} ${list.fav ? 'fav-selected' : ''}`}>
                                            <Icon name='star'
                                                size='md'

                                                style={list.fav ? 'fill' : 'line'}
                                                label='Fav'
                                                onClick={() => handleFavClicked(list)}
                                            />
                                        </td>
                                        <td className={`stored-criteria-table-content-cell static-columns ${!list.isRowEdit ? 'stored-criteria-table-highlighted-cell' : ''}${list.userName !== currentUser ? 'disabled-cursor' : ''}`} onClick={() => handleQueryNameClick(list, 'cell', 'queryName')}>
                                            {
                                                list.isQueryNameEdit ?
                                                    <TextInput
                                                        name='query-name-text'
                                                        multiLine={false}
                                                        autocomplete='off'
                                                        disabled={list.userName !== currentUser}
                                                        value={list.queryName ? list.queryName.toUpperCase() : list.queryName}
                                                        onChange={(event, value) => handleQueryNameUpdate(event, value, 'queryName', index)}
                                                    />
                                                    : <div className='spark-pad-l-.5'>{list.queryName.includes('--') ? list.queryName.slice(0, list.queryName.indexOf('--')) : list.queryName}</div>
                                            }
                                        </td>
                                        <td className='stored-criteria-table-content-cell spark-pad-l-.5'>{list.lastSavedDate}</td>
                                        <td className={`stored-criteria-table-content-cell static-columns ${!list.isRowEdit ? 'stored-criteria-table-highlighted-cell' : ''} ${list.userName !== currentUser ? 'disabled-cursor' : ''}`} onClick={() => handleQueryNameClick(list, 'cell', 'description')}>
                                            {
                                                list.isDescriptionEdit ?
                                                    <TextInput
                                                        name='description-text'
                                                        multiLine={false}
                                                        autocomplete='off'
                                                        disabled={list.userName !== currentUser}
                                                        value={list.description ? list.description.toUpperCase() : list.description}
                                                        onChange={(event, value) => handleQueryNameUpdate(event, value, 'description', index)}
                                                    />
                                                    : <div className='spark-pad-l-.5'>{list.description}</div>
                                            }
                                        </td>{
                                            storedCriteriaConfig.selectedUserName === 'All' && <td className='stored-criteria-table-content-cell spark-pad-l-.5'>{list.userName}</td>
                                        }
                                        {/* <td className='stored-criteria-table-content-cell row stored-criteria-table-item-center'><input type='checkbox' className={`${list.isRowEdit ? 'un-select' : 'checkbox'}`} checked={list.automated} /></td>
                                        <td className='stored-criteria-table-content-cell'>{list.autoTime}</td> */}
                                    </tr>)

                                }))
                            }
                        </tbody>
                    </table>{
                        storedCriteriaConfig.rowData.length === 0 && <NoRecord />
                    }
                </div>
            </div>
            <div className='row select-button col-md-12 col-lg-12'>
                <nav className='spark-btn-group spark-mar-t-1'>
                    <Button
                        name='select-button'
                        className='spark-btn-group-primary'
                        size={Button.SIZE.SMALL}
                        primary={true}
                        disabled={findEditRecords() || !storedCriteriaConfig.isSelectedRow}
                        onClick={handleSelectStoredCriteriaRecord}>SELECT</Button>
                    <Button
                        name='cancel-button'
                        className='spark-btn-group-secondary select-button-cancel'
                        size={Button.SIZE.SMALL}
                        secondary={true}
                        onClick={() => handleDeleteQueryName('Cancel')}>CANCEL</Button>
                </nav>
            </div>
        </div>
    )
};

StoredCriteria.propTypes = {
    data: object,
    currentUser: string,
    handleClosePopup: func,
    handleSelectStoredCriteria: func,
    reference: any,
    isOpen: any,
    reSetStoredCriteriaPopupFlag: func
};
export default StoredCriteria;